export const SET_BOOKING_FILTERS = 'SET_BOOKING_FILTERS';
export const GET_BOOKING_FILTERS = 'GET_BOOKING_FILTERS';

export const SET_SELECTED_BOOKING = 'SET_SELECTED_BOOKING';
export const GET_SELECTED_BOOKING = 'GET_SELECTED_BOOKING';

export const SET_BOOKINGS_VIEW_TYPE = 'SET_BOOKINGS_VIEW_TYPE';
export const GET_BOOKINGS_VIEW_TYPE = 'GET_BOOKINGS_VIEW_TYPE';
